import type { ReactNode } from 'react';
import { useTranslation } from 'react-i18next';
import { PageHeader, PageLayout } from '@eis/patterns';

export function HomePage(): ReactNode {
  const { t } = useTranslation('shell');
  return (
    <PageLayout header={<PageHeader title={t('home.title')} description={t('home.description')} />}>
      {null}
    </PageLayout>
  );
}
